import { Unit } from "uom";
// Delta temperature
export var DeltaCelsius = Unit.createBase("DeltaCelsius", "DeltaTemperature", "°C");
export var DeltaFahrenheit = Unit.timesNumber("DeltaFahrenheit", 5.0 / 9.0, DeltaCelsius);
//# sourceMappingURL=delta-temperature.js.map